import React, { Fragment } from "react";
import logo from "../../pavilionmanager.svg";

const Footer = (props) => {

    return (
        <Fragment>
            <section className="pb-4">
                <div className="container">
                    <div className="row mb-5">
                        <div className="mb-4 mb-lg-0 text-center text-md-left col-md-6 col-lg-6">
                            <div
                                className="navbar-brand font__size--20 text__20-1024 bold color__black"
                            >
                                <div className="brand-lockup d-flex align-items-end">
                                    <img src={logo} width="32" height="32" alt="PavilionManager" />

                                    <span className="ml-2">PavilionManager</span>
                                </div>
                            </div>
                            <p className="normal font__size--16 text__16-1024 color__gray-2">Corporate project and task management <br /> for teams and department heads.</p>
                        </div>
                        <div className="mb-4 mb-lg-0 text-center text-md-left col-md-3 col-lg-3">
                            <h5 className="bold font__size--14 text__14-1024 mb-3">Company</h5>
                            <ul className="bold font__size--16 text__16-1024 wrapper__list-menu">
                                <li><a href="#!" className="semi-bold color__gray-2">Platform</a></li>
                                <li><a href="#!" className="semi-bold color__gray-2">Pricing</a></li>
                                <li><a href="#!" className="semi-bold color__gray-2">FAQ</a></li>
                            </ul>
                        </div>
                        <div className="mb-4 mb-lg-0 text-center text-md-left col-md-3 col-lg-3">
                            <h5 className="bold font__size--14 text__14-1024 mb-3">Help</h5>
                            <ul className="bold font__size--16 text__16-1024 wrapper__list-menu">
                                <li><a href="#!" className="semi-bold color__gray-2">Implementation Support</a></li>
                                <li><a href="#!" className="semi-bold color__gray-2">Terms & Conditions</a></li>
                                <li><a href="#!" className="semi-bold color__gray-2">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <p className="mb-0 normal font__size--16 text__16-1024 color__gray-2 text-center">Copyright 2026, All Rights Reserved by PavilionManager</p>
                </div>
            </section>
        </Fragment>
    );
};

export default Footer;
